import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import themeReducer from "./theme/themeSlice";
import languageReducer from "./language/languageSlice";
import authReducer from "./auth/authSlice";

// Persist config for theme
const themePersistConfig = {
  key: "theme",
  storage,
};

// Persist config for language
const languagePersistConfig = {
  key: "language",
  storage,
};

// Persist config for auth - persist user, isAuthenticated, and access token
// Refresh token is stored in secure HTTP-only cookie, not in Redux
const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["user", "isAuthenticated", "accessToken"], // Only persist access token
};

const persistedThemeReducer = persistReducer(themePersistConfig, themeReducer);
const persistedLanguageReducer = persistReducer(
  languagePersistConfig,
  languageReducer
);
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);

export const store = configureStore({
  reducer: {
    theme: persistedThemeReducer,
    language: persistedLanguageReducer,
    auth: persistedAuthReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
